<script setup>
import AdvancedFileManager from '@/views/apps/file/list/AdvancedFileManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'files',
    layoutWrapperClasses: 'layout-content-height-fixed',
  },
})
</script>

<template>
  <AdvancedFileManager />
</template>

